import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { NewsService } from '../../../core/services/news/news.service';
import { LoadingComponent } from "../../../shared/loading/loading.component";
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-new',
  standalone: true,
  imports: [CommonModule, LoadingComponent, RouterLink],
  templateUrl: './new.component.html',
  styleUrl: './new.component.scss'
})
export class NewComponent implements OnInit {

  news: any = null;
  loading = true;

  constructor(
    private route: ActivatedRoute,
    private newsService: NewsService,
    private meta: Meta,
    private title: Title
  ) {}

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id')!;

    this.newsService.getNewsById(id).subscribe((data) => {
      this.news = data;
      this.loading = false;

      if (this.news) {
        this.updateMetaTags();
      }
    });
  }

  private updateMetaTags(): void {
    const pageUrl = window.location.href;
    const title = this.news.title || 'خبر من راديو الغردقة';
    const description =
      (this.news.article || '').slice(0, 150) + '...' ||
      'اقرأ المزيد من الأخبار عبر موقع راديو الغردقة.';
    const image = this.news.image || 'https://hurghadaradio.com/assets/images/logo.png';

    // Browser tab title
    this.title.setTitle(title);

    // Remove old OG tags (optional, but clean)
    this.meta.removeTag("property='og:title'");
    this.meta.removeTag("property='og:description'");
    this.meta.removeTag("property='og:image'");
    this.meta.removeTag("property='og:url'");
    this.meta.removeTag("property='og:type'");

    // Add new OG tags
    this.meta.addTags([
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:image', content: image },
      { property: 'og:url', content: pageUrl },
      { property: 'og:type', content: 'article' }
    ]);

    // Optional: Twitter Card
    this.meta.addTags([
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: image }
    ]);
  }

  share(item: any) {
    const url = window.location.href;
    const title = item.title || "خبر من راديو الغردقة";
    const text =
      item.article?.slice(0, 150) + "..." ||
      "اقرأ المزيد من الأخبار عبر موقع راديو الغردقة.";

    if (navigator.share) {
      navigator.share({
        title: title,
        text: text,
        url: url
      })
      .then(() => {
        alert("تمت مشاركة الخبر بنجاح 🌟\nشكراً لمشاركتك أخبار راديو الغردقة ❤️");
      })
      .catch((err) => console.error("Share error:", err));

    } else {
      navigator.clipboard.writeText(url);
      alert("تم نسخ رابط الخبر بنجاح! 📋\nيمكنك الآن مشاركته أينما تريد ❤️");
    }
  }
}